import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconInfoLine(props: SvgIconProps) {
  return (
    <SVGIcon width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M7.31695 11H8.68495V7.169H7.31695V11Z" fill="currentColor" />
      <path
        d="M7.99195 5C7.55995 5 7.19995 5.36 7.19995 5.801C7.19995 6.242 7.55995 6.602 7.99195 6.602C8.44195 6.602 8.80195 6.242 8.80195 5.801C8.80195 5.36 8.44195 5 7.99195 5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM13 8C13 10.7614 10.7614 13 8 13C5.23858 13 3 10.7614 3 8C3 5.23858 5.23858 3 8 3C10.7614 3 13 5.23858 13 8Z"
        fill="currentColor"
      />
    </SVGIcon>
  );
}
